import { useUserSession } from '@solinkcorp/authentication';
import { usePrevious } from '@solinkcorp/solink-components';
import React, { useEffect, useMemo } from 'react';
import { useUserFeatureStandard } from 'utils/EventStandardCache/eventStandardCache';
import FeaturesUtil from 'utils/FeaturesUtil';

/**
 * A simple component that syncs clones of userFeatures and userFeatureStandard in FeatureUtils module
 * when the user changes
 */
const UserFeatureProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const user = useUserSession();
  const userFeatureStandard = useUserFeatureStandard();

  const prevUser = usePrevious(user);

  /** sync default features in FeaturesUtil module if user changes */
  const defaultFeatures = useMemo(() => {
    const features: Record<string, boolean> = {};
    if (userFeatureStandard) {
      for (const [k, v] of Object.entries(userFeatureStandard)) {
        features[k] = v.defaults?.[user.profile.userType] || false;
      }
    }
    return features;
  }, [userFeatureStandard, user.profile.userType]);

  useEffect(() => {
    FeaturesUtil.updateDefaultUserFeatures(defaultFeatures);
  }, [defaultFeatures]);

  /** sync clones of userFeatures and userFeatureStandard in FeatureUtil module if user changes */
  useEffect(() => {
    if (user.userId !== prevUser?.userId) {
      FeaturesUtil.updateUserFeatures(user.profile.features || {});
    }
  }, [user, prevUser, userFeatureStandard]);

  return <>{children}</>;
};

export default UserFeatureProvider;
